import DateTimeField from 'admin-config/lib/Field/DateTimeField';
class TimestampField extends DateTimeField {
    constructor(name) {
        super(name);
        this._type = 'unixtime';
    }
}
module.exports = TimestampField;


// WEBPACK FOOTER //
// ./client/app/fields/unixtime.js